export const downloadUrl = 'http://cashier.ubitdev.com/';
export const toSettingUrl = 'https://download.yubitap.com/pwa/prd.mobileprovision';
export const iosInstallList = [
    {
        url: '',
        pingUrl: 'https://www.yubitcoin.asia/favicon.ico',
        domain: 'https://www.yubitcoin.asia',
    },
    {
        url: '',
        pingUrl: 'https://www.ubtuser.com/favicon.ico',
        domain: 'https://www.ubtuser.com',
    },
    {
        url: '',
        pingUrl: 'https://www.ubit.asia/favicon.ico',
        domain: 'https://www.ubit.asia',
    },
];
export const androidInstallList = [
    {
        url: 'https://download.ubitdl.com/apk/ubit-rp-prd-11178.apk',
    },
    {
        url: 'https://download.yubitap.com/apk/ubit-rp-prd-11178.apk',
    },
];
